import { useDebouncedValue } from '@mantine/hooks';
import { createContext, useState } from 'react';

export const useBookLayout = () => {
  const [selectedItem, setSelectedItem] = useState<string>('');
  const [itemQuantity, setItemQuantity] = useState<number>(1);
  const [isItem, setIsItem] = useState<boolean>(false);
  const [isQuantity, setIsQuantity] = useState<number>(0);
  const [previousQuantity, setPreviousQuantity] = useState<number>(0);
  const [getData, setGetData] = useState<number>(0);
  const [checked, setChecked] = useState<boolean>(false);
  const [inputValue, setInputValue] = useState<string>('');
  const [debounced] = useDebouncedValue(inputValue, 200);
  const [active, setActive] = useState('all');
  const [addOn, setAddOn] = useState<any[]>([]);
  const [menuItemId, setMenuItemId] = useState('');
  const [cartItemId, setCartItemId] = useState('');
  const [addOnTotalPrice, setAddOnTotalPrice] = useState<number>(0);
  const [cartItems, setCartItems] = useState([]);
  const [perItem, setPerItem] = useState<number>(0);
  const [couponPayload, setCouponPayload] = useState('');
  const [tokenInput, setTokenInput] = useState('');
  const [userName, setUserName] = useState('');
  const [phoneNumber, setPhoneNumber] = useState<any>(null);
  const [emailAddress, setEmailAddress] = useState<any>(null);
  const [enableCheckOut, setEnableCheckOut] = useState<boolean>(false);

  return {
    selectedItem,
    setSelectedItem,
    itemQuantity,
    setItemQuantity,
    isItem,
    setIsItem,
    isQuantity,
    setIsQuantity,
    previousQuantity,
    setPreviousQuantity,
    getData,
    setGetData,
    checked,
    setChecked,
    inputValue,
    setInputValue,
    debounced,
    active,
    setActive,
    addOn,
    setAddOn,
    menuItemId,
    setMenuItemId,
    cartItemId,
    setCartItemId,
    addOnTotalPrice,
    setAddOnTotalPrice,
    cartItems,
    setCartItems,
    perItem,
    setPerItem,
    couponPayload,
    setCouponPayload,
    tokenInput,
    setTokenInput,
    userName,
    setUserName,
    phoneNumber,
    setPhoneNumber,
    emailAddress,
    setEmailAddress,
    enableCheckOut,
    setEnableCheckOut,
  };
};

export const BookingContext = createContext({} as ReturnType<typeof useBookLayout>);
